//TODO - this should be a setting one day

import { WFType } from "@vierkant-software/types__api";
import { Filter } from "../modules/ngx-workflow/services/workflow.service";
import { sortBy } from "src/util/sort";

export interface WorkflowCategory {
  id: string | undefined;
  name: string;
  filter: Filter;
}

export const defaultFilterFilter = Object.freeze({
  wfTypes:     [],
  showDelayed: true,
});

export const workflowCategories: WorkflowCategory[] = [
  {
    id:     'all',
    name:   'Alle',
    filter: {
      wfTypes:   [],
      hideEmpty: false,
    },
  },
  {
    id:     'filtered',
    name:   'Gefiltert',
    filter: {...defaultFilterFilter}
  },
  ...sortBy([
    {
      id:     'shiftExchange',
      name:   'Schichtbörse',
      filter: {
        wfTypes: [WFType.shiftExchange],
      },
    },
    {
      id:     'contracts',
      name:   'Verträge',
      filter: {
        wfTypes: [WFType.memberContractOnlineCreated],
      },
    },
    {
      id:     'appointments',
      name:   'Termine',
      filter: {
        wfTypes: [WFType.appointment],
      },
    },
    {
      id:     'adminTicket',
      name:   'Admin-Ticket', //Ticket without an interesting name
      filter: {
        wfTypes: [WFType.adminTicket],
      },
    },
    {
      id:     'aggregatorEGYM',
      name:   'EGYM',
      filter: {
        wfTypes: [WFType.aggregatorEGYM],
      },
    }


    // add above this line
  ], x => x.name.toLowerCase())
];